import { ApiResponseData } from "../../services/YourAppServer/YourAppServerApi.service";
import Utils from "../utils";
import { Moment } from "moment";
import { Gender, RemoveCustomerFurtherAddressSuccessModelErrorCode } from "../contentTypes";
import { environment } from "../../../../environments/environment";

export class UserWebvoucherViewModel {
  public webvoucherQRCode: string;
  public webvoucherNumber: string;
}

export class UserDetailInfoViewModel {
  public name: string; // max length 30
  public fname: string; // max length 30
  public email: string;
  public bday_ymd: number;
  public gender: number;
  public zip_code: string;
  public co: string; // max. 30
  public address: string; // max. 40
  public addition: string; // max. 25
  public city: string; // max. 30
  public country: string; // max. 30
  public telephone1: string; // max. 20, privat
  public telephone_mobile: string; // max. 20
  public furtherAddress: FurtherAddressViewModel[]
}

export class UserInfoViewModel {
  public name: string; // max length 30
  public fname: string; // max length 30
  public email: string;
}

export class FurtherAddressViewModel {
  id: string; // id as token
  co: string; // max. 30
  address: string; // max. 40
  addition: string; // max. 25
  zip_code: string; // max. 10
  city: string; // max. 30
  country: string; // max. 30
}

export class UserAddressViewModel {
  id: string; // id as token
  co: string; // max. 30
  address: string; // max. 40
  addition: string; // max. 25
  zip_code: string; // max. 10
  city: string; // max. 30
  country: string; // max. 30
}

/** Enums */
export enum AddressType {
  Main = 0,
  Delivery = 1
}

export enum SetCustomerMainAddressSuccessModelErrorCode {
  UndefinedError = 0,
  NoAccountID = 1,
  NoRequestData = 2,
  ResponseIsEmpty = 3,
  ResponseDataIsEmpty = 4,
  ResponseDataSetIsEmpty = 5,
  InvalidRequest = 6,
  ValidationError = 7,
  DataRecordCreationNotpossible = 8,
  UnKnownConnectorError = 9,
  AccountIDnotCorrect = 10
}

export enum SetCustomerFurtherAddressSuccessModelErrorCode {
  UndefinedError = 0,
  NoAccountID = 1,
  NoRequestData = 2,
  ResponseIsEmpty = 3,
  ResponseDataIsEmpty = 4,
  ResponseDataSetIsEmpty = 5,
  InvalidRequest = 6,
  ValidationError = 7,
  DataRecordCreationNotpossible = 8,
  UnKnownConnectorError = 9,
  AccountIDnotCorrect = 10,
  CustomerIDnotCorrect = 11
}

export enum AnonymizeCustomerSuccessModelErrorCode {
  UndefinedError = 0,
  NoAccountID = 1,
  NoRequestData = 2,
  ResponseIsEmpty = 3,
  ResponseDataIsEmpty = 4,
  ResponseDataSetIsEmpty = 5,
  InvalidRequest = 6,
  ValidationError = 7,
  DataRecordCreationNotpossible = 8,
  UnKnownConnectorError = 9,
  AccountIDnotCorrect = 10,
  CustomerIDnotCorrect = 11
}

export class FurtherAddress {
  token: string; // id as token
  address_type: AddressType;
  co: string; // max. 30
  address: string; // max. 40
  addition: string; // max. 25
  zip: string; // max. 10
  city: string; // max. 30
  country: string; // max. 30
  telefon: string; // max. 20
}

export class UserInfoData {

  /** me wird erweitert um neue werte aus model */
  public static ReadFromModel(me: UserInfoData, model: UserInfoModel3): void {
    me.loaded = true;
    me.need_upload = false;
    me.is_testuser = model.is_testuser ? model.is_testuser : me.is_testuser;
    me.name = model.name ? model.name : me.name;
    me.fname = model.fname ? model.fname : me.fname;
    me.bday_ymd = model.bday_ymd ? model.bday_ymd : me.bday_ymd;
    me.gender = model.gender ? model.gender : me.gender;
    me.zip_code = model.zip_code ? model.zip_code : me.zip_code;
    me.card_number = model.card_number ? model.card_number : me.card_number;
    me.card_url = model.card_url ? model.card_url : me.card_url;
    me.email = model.email ? model.email : me.email;
    me.login_provider = model.login_provider ? model.login_provider : me.login_provider;
    me.changed_at_ymd = model.changed_at_ymd ? model.changed_at_ymd : me.changed_at_ymd;
    me.changed_at_hms = model.changed_at_hms ? model.changed_at_hms : me.changed_at_hms;
    me.changed_by = model.changed_by ? model.changed_by : me.changed_by;
    me.pe = model.pe ? model.pe : me.pe; // Preisebene
    me.discount = model.discount ? model.discount : me.discount; // Rabatt
    me.prefix = model.prefix ? model.prefix : me.prefix; // max. 10
    me.is_company = model.is_company ? model.is_company : me.is_company; // max. 30
    me.co = model.co ? model.co : me.co; // max. 30
    me.address = model.address ? model.address : me.address; // max. 40
    me.addition = model.addition ? model.addition : me.addition; // max. 25
    me.city = model.city ? model.city : me.city; // max. 30
    me.country = model.country ? model.country : me.country; // max. 30
    me.telephone1 = model.telephone1 ? model.telephone1 : me.telephone1; // max. 20, privat
    me.telephone2 = model.telephone2 ? model.telephone2 : me.telephone2; // max. 20, geschäftlich
    me.telephone_mobile = model.telephone_mobile ? model.telephone_mobile : me.telephone_mobile; // max. 20
    me.fax = model.fax ? model.fax : me.fax; // max. 20
    me.telephone1_start_time = model.telephone1_start_time ? model.telephone1_start_time : me.telephone1_start_time; // hhmmss
    me.telephone1_end_time = model.telephone1_end_time ? model.telephone1_end_time : me.telephone1_end_time; // hhmmss
    me.telephone2_start_time = model.telephone2_start_time ? model.telephone2_start_time : me.telephone2_start_time; // hhmmss
    me.telephone2_end_time = model.telephone2_end_time ? model.telephone2_end_time : me.telephone2_end_time; // hhmmss
    me.tag_disliked_ids = model.tag_disliked_ids ? model.tag_disliked_ids : me.tag_disliked_ids;
    me.tag_liked_ids = model.tag_liked_ids ? model.tag_liked_ids : me.tag_liked_ids;
    me.AllowMailNewsletter = model.AllowMailNewsletter !== undefined ? model.AllowMailNewsletter : me.AllowMailNewsletter;
    me.AllowMailNewsletterChangedAt = model.AllowMailNewsletterChangedAt ? model.AllowMailNewsletterChangedAt : me.AllowMailNewsletterChangedAt;
    if (model.further_addresses) {
      me.further_addresses = [];
      for (const address of model.further_addresses) {
        const faddress = new FurtherAddress();
        faddress.addition = address.addition ? address.addition : faddress.addition;
        faddress.address = address.address ? address.address : faddress.address;
        faddress.address_type = address.address_type ? address.address_type : faddress.address_type;
        faddress.city = address.city ? address.city : faddress.city;
        faddress.co = address.co ? address.co : faddress.co;
        faddress.country = address.country ? address.country : faddress.country;
        faddress.telefon = address.telefon ? address.telefon : faddress.telefon;
        faddress.token = address.token ? address.token : faddress.token;
        faddress.zip = address.zip ? address.zip : faddress.zip;
        me.further_addresses.push(faddress);
      }
    }
  }

  public loaded: boolean = false;
  public need_upload: boolean = false;
  // eventuell ein AccountToken?
  public is_testuser: boolean = false;
  public name: string; // max length 30
  public fname: string; // max length 30
  public bday_ymd: number;
  public gender: Gender;
  public zip_code: string; // max length 10
  public card_number: string;
  public card_url: string;

  public pe: number; // Preisebene
  public discount: number; // Rabatt

  public prefix: string; // max. 10
  public is_company: boolean; // max. 30
  public co: string; // max. 30
  public address: string; // max. 40
  public addition: string; // max. 25
  public city: string; // max. 30
  public country: string; // max. 30
  public telephone1: string; // max. 20, privat
  public telephone2: string; // max. 20, geschäftlich
  public telephone_mobile: string; // max. 20
  public fax: string; // max. 20
  public telephone1_start_time: number; // hhmmss
  public telephone1_end_time: number; // hhmmss
  public telephone2_start_time: number; // hhmmss
  public telephone2_end_time: number; // hhmmss
  public further_addresses: FurtherAddress[];
  public tag_disliked_ids: number[];
  public tag_liked_ids: number[];
  public AllowMailNewsletter: boolean;
  public AllowMailNewsletterChangedAt: Date;

  public get card_qr_code_url(): string {
    const me = this;
    if (Utils.IsNull(me.card_number) || me.card_number.length < 10) {
      return "";
    } else {
      if (Utils.IsNull(me.card_url) || me.card_url.length < 10) {
        return `https://myhypersoft.de/Codes.aspx?HYNR=${environment.HypCusNumber}&HYGS=${me.card_number}`;
      } else {
        return me.card_url + me.card_number;
      }
    }
  }
  public email: string; // max. 63
  public login_provider: string;
  public changed_at_ymd: number;
  public changed_at_hms: number;
  public get changed_at(): Moment {
    return Utils.GetMomentFromInt(this.changed_at_ymd, this.changed_at_hms);
  }
  public changed_by: number;

}

// Requests
export class SetUserInfoModel {
  public version: number;
  public data: object;
}

export class RemoveCustomerFurtherAddressDataModel {
  public token: string;
}

export class RemoveCustomerFurtherAddressSuccessModel {
  /// <summary>
  /// success when update or insert possible
  /// </summary>
  public success: boolean
  public error: RemoveCustomerFurtherAddressSuccessModelErrorCode
  public token: string

  public DeserializeType(): void {
    // has no complex type
  }
}


// MainAddress kann sein:
// name; // max. 30
// fname; // max. 30
// bday_ymd; // yyyyMMdd
// gender;
// zip_code; // max. 10
// email; // max. 63
// prefix; // max. 10
// is_company; // max. 30
// co; // max. 30
// address; // max. 40
// addition; // max. 25
// city; // max. 30
// country; // max. 30
// telephone1; // max. 20, privat
// telephone2; // max. 20, geschäftlich
// telephone_mobile; // max. 20
// fax; // max. 20
// telephone1_start_time; // hhmmss
// telephone1_end_time; // hhmmss
// telephone2_start_time; // hhmmss
// telephone2_end_time; // hhmmss
export class SetCustomerMainAddressDataModel {
  public address: { [key: string]: string | number };
}

// FurtherAddress kann sein:
// int - AddresstypeID : AddressType
// string - CusCo // max. 30
// string - POB // max. 10
// string - Adress // max. 40
// string - Plz // max. 10
// string - City // max. 30
// string - Country // max. 30
// string - Tel1 // max. 20
// string - Addition // max. 25
export class SetCustomerFurtherAddressDataModel {
  public token: string; // "" > if new
  public address: { [key: string]: string | number };
}

// Responses
export class UserInfoModel3 implements ApiResponseData {
  // eventuell ein AccountToken
  public is_testuser: boolean;
  public name: string; // max. 30
  public fname: string; // max. 30
  public bday_ymd: number; // yyyyMMdd
  public gender: number;
  public zip_code: string; // max. 10
  public card_number: string;
  public card_url: string;
  public email: string; // max. 63
  public login_provider: string;

  public pe: number; // Preisebene
  public discount: number; // Rabatt

  public prefix: string; // max. 10
  public is_company: boolean; // max. 30
  public co: string; // max. 30
  public address: string; // max. 40
  public addition: string; // max. 25
  public city: string; // max. 30
  public country: string; // max. 30
  public telephone1: string; // max. 20, privat
  public telephone2: string; // max. 20, geschäftlich
  public telephone_mobile: string; // max. 20
  public fax: string; // max. 20
  public telephone1_start_time: number; // hhmmss
  public telephone1_end_time: number; // hhmmss
  public telephone2_start_time: number; // hhmmss
  public telephone2_end_time: number; // hhmmss
  public further_addresses: FurtherAddress[];
  public tag_liked_ids: number[];
  public tag_disliked_ids: number[];

  public changed_at_ymd: number;
  public changed_at_hms: number;
  public changed_by: number;

  public AllowMailNewsletter: boolean;
  public AllowMailNewsletterChangedAt: Date;

  public DeserializeType(): void {
    // has no complex type
  }
}

export class SetCustomerMainAddressSuccessModel implements ApiResponseData {
  public success: boolean;
  public error: SetCustomerMainAddressSuccessModelErrorCode;

  public DeserializeType(): void {
    // has no complex type
  }
}

export class SetCustomerFurtherAddressSuccessModel implements ApiResponseData {
  public success: boolean;
  public token: string;
  public error: SetCustomerFurtherAddressSuccessModelErrorCode;

  public DeserializeType(): void {
    // has no complex type
  }
}

export class SetCustomerArtikelTagModel {
  public tags_liked: number[];
  public tags_disliked: number[];
}

export class SetCustomerArtikelTagsSuccessModel implements ApiResponseData {
  public success: boolean;

  public DeserializeType(): void {
    // has no complex type
  }
}

export class AnonymizeCustomerSuccessModel {
  public success: boolean
  public error: AnonymizeCustomerSuccessModelErrorCode

  public DeserializeType(): void {
    // has no complex type
  }
}
